// @core/api/endpoints/userprofile/set_ui_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetUISettingsRequest,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Set UI settings for profile
 * Updates the user's UI preferences. Changes take effect immediately and sync across all active sessions.
 */
export async function SetUISettings(
  profile_id: string,
  data: SetUISettingsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/settings/ui`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
